/* 🤖 this file was generated by svg-to-ts */
export const svgPinMinimalist: {
    name: "pin-minimalist";
    data: string;
} = {
    name: "pin-minimalist",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__pin-minimalist" viewBox="0 0 24 23"><circle cx="12" cy="10.1" r="1"/><path d="m12.04855,4.7c-3.1,0 -5.6,2.5 -5.6,5.6c0,1.3 0.4,2.5 1.2,3.5l3.6,4.5l0.8,1l0.8,-1l2.9,-3.7l0.6,-0.8c0.8,-1 1.2,-2.2 1.2,-3.5c0.1,-3.1 -2.4,-5.6 -5.5,-5.6zm3.6,8.5l-0.6,0.8l-3,3.7l-3.6,-4.5c-0.7,-0.8 -1,-1.8 -1,-2.9c0,-2.5 2,-4.6 4.6,-4.6s4.6,2.1 4.6,4.6c0,1.1 -0.4,2.1 -1,2.9z"/></symbol></svg>`,
};
